/**
 * 题目 api
 * 题目 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The QuestionOptionVo model module.
   * @module drill/model/QuestionOptionVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>QuestionOptionVo</code>.
   * @alias module:drill/model/QuestionOptionVo
   * @class
   */
  var exports = function() {
    var _this = this;





  };

  /**
   * Constructs a <code>QuestionOptionVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:drill/model/QuestionOptionVo} obj Optional instance to populate.
   * @return {module:drill/model/QuestionOptionVo} The populated <code>QuestionOptionVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'text')) {
        obj['text'] = ApiClient.convertToType(data['text'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'imageUri')) {
        obj['imageUri'] = ApiClient.convertToType(data['imageUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'correctAnswer')) {
        obj['correctAnswer'] = ApiClient.convertToType(data['correctAnswer'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * 大写字母A、B、C、D
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 选项文本
   * @member {String} text
   */
  exports.prototype['text'] = undefined;
  /**
   * 图片地址
   * @member {String} imageUri
   */
  exports.prototype['imageUri'] = undefined;
  /**
   * 正确答案
   * @member {Boolean} correctAnswer
   */
  exports.prototype['correctAnswer'] = undefined;



  export default exports;
;


